import httpManager from "@/app/shared/utils/httpManager";
/**
 * Obtener un usuario mediante su id.
 *
 * @return {Promise<Object>} Usuario por id
 */
export default async function () {
  const response = await httpManager.getBlob(`/users/download/`);
  return response;
}
